<!--
 * @description: 左侧导航信息
 * @param: 
 * @return: 
-->
<template>
  <div class="navi-config-container">
    <panel-container class="navi">
      <title-panel class="navi-left-title-panel">
        <template v-slot:left>菜单预览</template>
      </title-panel>
      <div class="left-body">
        <div
          class="navi-item-container"
          v-for="(item, index) in naviData"
          :key="`naviConfig${index}`"
        >
          <div
            class="navi-item-container-left"
            @click="handClick(item, $event)"
          >
            <div class="logo"></div>
            <div class="text">{{ item.text }}</div>
            <div class="arrow"></div>
          </div>
          <div class="navi-item-container-right">
            <div
              class="navi-sub-item"
              v-for="(child, childIndex) in item.children"
              :key="`naviSubConfig${childIndex}`"
              @click="handClick(child, $event)"
            >
              <div class="text">{{ child.text }}</div>
              <div class="arrow"></div>
              <div
                class="item-container"
                v-if="child.children && child.children.length > 0"
              >
                <div
                  class="item"
                  v-for="(childItem, childItemIndex) in child.children"
                  :key="`naviSubConfigItem${childItemIndex}`"
                  @click="handClick(childItem, $event)"
                >
                  {{ childItem.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </panel-container>

    <panel-container class="navi navi-right">
      <title-panel class="navi-left-title-panel">
        <template v-slot:left>编辑菜单</template>
      </title-panel>
      <div class="right-body">
        <div class="field-items">
          <text-field
            class="field"
            labelText="菜单等级"
            v-model:value="rightNavValue.grade"
            placeholder="请选择"
            type="select"
            labelAlign="top"
            :requird="true"
            :fieldData="selectData"
          ></text-field>
          <text-field
            class="field"
            v-model:value="rightNavValue.text"
            labelText="菜单名称"
            labelAlign="top"
            :requird="true"
          ></text-field>
          <text-field
            class="field"
            v-model:value="rightNavValue.onOrOff"
            labelText="开启/关闭"
            type="radio"
            labelAlign="top"
            :requird="true"
            :fieldData="radioData"
          ></text-field>

          <text-field
            v-model:value="rightNavValue.path"
            class="field"
            labelText="菜单路径"
            labelAlign="top"
            :requird="true"
          ></text-field>
          <text-field
            v-model:value="rightNavValue.filePath"
            class="field"
            labelText="文件地址"
            labelAlign="top"
            :requird="false"
          ></text-field>
        </div>
      </div>
      <div class="showTitle" v-bind="rightNavValue">
        <div class="titleFirst">
          已选择
          <span class="textRed"> {{ rightNavValue.grade }} </span>级菜单， ---
          <span style="color: red">{{ rightNavValue.text }}</span> 项
        </div>
        <div class="btnBOX">
          <update-button
            class="addbutton"
            :useConfirm="true"
            comfirmMessage="确定修改吗？"
            comfirmOkText="确定"
            comfirmCancelText="取消"
            @buttonClick="HandReset"
          >
            修改
          </update-button>
          <del-button
            class="addbutton"
            :useConfirm="true"
            comfirmMessage="确定删除吗？"
            comfirmOkText="确定"
            comfirmCancelText="取消"
            @buttonClick="handDelete"
          >
            删除
          </del-button>
          <add-button
            class="addbutton"
            :useConfirm="true"
            comfirmMessage="确定新增吗？"
            comfirmOkText="确定"
            comfirmCancelText="取消"
            @buttonClick="addHandClick"
          >
            新增
          </add-button>
        </div>
      </div>
    </panel-container>
  </div>
</template>

<script>
import titlePanel from "@/components/titlePanel.vue";
import panelContainer from "@/components/panelContainer.vue";
import { naviConfigAllNavi, addNav, naviData } from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";
import textField from "@/components/textField.vue";
import delButton from "@/components/delButton.vue";
import addButton from "@/components/addButton.vue";
import updateButton from "@/components/updateButton.vue";
import controlButton from "@/components/controlButton.vue";
import AddButton from "../components/addButton.vue";
import DelButton from "../components/delButton.vue";

export default {
  name: "naviConfig",
  components: {
    titlePanel,
    panelContainer,
    textField,
    controlButton,
    delButton,
    addButton,
    updateButton,
    AddButton,
    DelButton,
  },
  data() {
    return {
      show: true,
      naviData: [],
      naviItemSelected: -1,
      selectData: [
        {
          label: "一级菜单",
          value: "1",
        },
        {
          label: "二级菜单",
          value: "2",
        },
        {
          label: "三级菜单",
          value: "3",
        },
      ],
      radioData: [
        {
          label: "开启",
          value: 0,
        },
        {
          label: "关闭",
          value: 1,
        },
      ],
      rightNavValue: {
        text: "", // 文本
        fid: 0, //
        permission: "", //
        //resourceType: 1, //
        path: "", // 路径
        filePath: "", // 路径
        grade: null, // 等级
        id: null, // id
        onOrOff: 0, // 开启、关闭 0&1
      },
      sum: "",
    };
  },
  mounted() {
    this.getNaviData();
  },
  watch: {
    // 'rightNavValue.Grade':function(newVal,oldVal){
    //     console.log('Grade变化')
    //     // this.rightNavValue.Grade = newVal
    // }
  },
  methods: {
    handleClose() {
      // this.show = false
      this.rightNavValue.grade = null;
      this.rightNavValue.id = null;
    },
    // 新增菜单
    addHandClick() {
      if (this.rightNavValue.grade === null) {
        errMsg("没有菜单");
        return;
      }
      let { text, fid, path, filePath, grade, onOrOff, id } =
        this.rightNavValue;
      if (grade == "1") {
        fid = 0;
      } else {
        fid = id;
      }

      addNav("api/InitTree/AddInitTree", {
        text,
        fid,
        path,
        filePath,
        grade,
        onOrOff,
      }).then((data) => {
        this.getNaviData();
        successMsg(data.message);
      });
    },
    // 修改菜单
    HandReset() {
      if (
        (this.rightNavValue.grade === null) &
        (this.rightNavValue.id === null)
      ) {
        return errMsg("没有选择要修改菜单");
      }

      let Reset = this.rightNavValue;
      Reset.permission = Reset.text;
      addNav("api/InitTree/UpdateInitTree", Reset).then((data) => {
        this.getNaviData();
        this.rightNavValue.grade = null;
        this.rightNavValue.id = null;
        successMsg(data.message);
      });
    },

    // 删除菜单
    handDelete() {
      if (
        (this.rightNavValue.grade === null) &
        (this.rightNavValue.id === null)
      ) {
        return errMsg("没有选择要删除菜单");
      }
      let id = this.rightNavValue.id;

      addNav("api/InitTree/DeleteInitTree", { id }).then((data) => {
        successMsg(data.message);
        this.getNaviData();
      });
    },
    // 菜单选项
    handClick(value, event) {
      if (event) {
        console.log(event, "event");
        event.stopPropagation
          ? event.stopPropagation()
          : (event.cancelBubble = true);
      }
      console.log(event, "aa");

      this.rightNavValue.fid = value.fid;
      this.rightNavValue.id = value.id;
      this.rightNavValue.text = value.text;
      this.rightNavValue.grade = value.grade;
      this.rightNavValue.path = value.path;
      this.rightNavValue.onOrOff = value.onOrOff;
      this.rightNavValue.filePath = value.filePath;
      this.rightNavValue.permission = value.permission;
    },
    // 菜单列表
    /**
     * @description: 获取菜单列表
     * @param {*}
     * @return {*}
     */
    getNaviData() {
      let paramType = {
        resource_type: 1,
      };
      naviData()
        .then((data) => {
          if (data.code == 0) {
            this.naviData = data.data.children;
          } else {
            errMsg(data.message);
          }
        })
        .catch((data) => {
          errMsg(data.message);
        });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "@/assets/styles/_handle.scss";

.el-button {
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}
.navi-config-container {
  width: 100%;
  height: 100%;
  display: flex;

  .navi {
    flex: 1;
    height: auto;
    display: flex;
    flex-direction: column;

    &.navi-right {
      position: relative;
      margin-left: 40px;
      // height: 600px;

      .showTitle {
        padding: 0 10px;
        .titleFirst {
          font-size: 18px;
        }
      }
      .btnBOX {
        display: flex;
        justify-content: flex-end;
        height: 60px;
        span {
          margin-left: 30px !important;
        }
        .addbutton {
          margin-left: 10px;
        }
      }
    }

    .navi-left-title-panel {
      margin-left: 20px;
    }

    .left-body {
      @include border_top("navi-title-bottom-line");
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 30px 60px;
      box-sizing: border-box;
      overflow: auto;

      .navi-item-container {
        width: 100%;
        height: auto;
        display: flex;
        cursor: pointer;
        margin-top: 30px;
        align-items: flex-start;
        align-content: flex-start;

        .navi-item-container-left {
          width: auto;
          height: auto;
          display: flex;
          align-items: center;
          align-content: center;

          &:first-child {
            margin-top: 0px;
          }

          .logo {
            height: 24px;
            width: 24px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            @include background_image("naviItem_logo_normal");
          }

          .arrow {
            width: 10px;
            height: 16px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            @include background_image("naviItem_arrow_normal");
            margin-left: 45px;
          }

          .text {
            width: 60px;
            height: 18px;
            line-height: 18px;
            font-size: 18px;
            margin-left: 10px;
            @include font_family("font_family");
            @include font_color("naviItem_font-color_normal");
            width: auto;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .navi-item-container-right {
          margin-left: 60px;
          display: flex;
          flex-direction: column;
          width: 100%;
          height: auto;

          .navi-sub-item {
            width: 100%;
            height: auto;
            display: flex;
            margin-top: 20px;

            &:first-child {
              margin-top: 0px;
            }

            .text {
              height: 16px;
              line-height: 16px;
              font-size: 16px;
              @include font_family("font_family");
              @include font_color("naviItemExpend_text-olor");
              width: fit-content;
            }

            .arrow {
              width: 10px;
              height: 16px;
              margin-left: 10px;
              background-repeat: no-repeat;
              background-size: 100% 100%;
              @include background_image("naviItemExpend_arrow_bg-image");
            }

            .item-container {
              margin-left: 20px;
              display: flex;
              flex-wrap: wrap;
              height: auto;
              flex: 1;

              .item {
                margin-left: 20px;
                @include font_family("font_family");
                height: 14px;
                line-height: 14px;
                width: auto;
                font-size: 14px;
                margin-bottom: 10px;
                @include font_color("naviItemExpend_item_text-color");
              }
            }
          }
        }
      }
    }

    .right-body {
      @include border_top("navi-title-bottom-line");
      width: auto;
      display: flex;
      flex-direction: column;
      padding-top: 40px;
      padding-bottom: 40px;
      padding-right: 40px;
      box-sizing: border-box;
      overflow: auto;
      box-sizing: border-box;

      .field-items {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        height: auto;

        .field {
          margin-left: 40px;
          margin-bottom: 40px;

          .el-radio__inner {
            width: 15px;
            height: 15px;
          }
        }
      }
    }
  }
  .textRed {
    color: red;
  }
}
</style>
